import React, { useState, useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

// import JS files
import MuiModal from "../shares/MuiModal";
import MuiTextFieldHook from "../shares/MuiTextFieldHook";
import MuiButton from "../shares/MuiButton";
import useFetch from "../../context/useFetch";

// import Others files
import mobileIcon from "../../imgs/mobile-icon.svg";
import otpIcon from "../../imgs/otp-icon.svg";
import { useAuth } from "../../context/AuthContext";
import { fixNumbers } from "../../Utils";

const OtpModal = (props) => {
  const {
    watch,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      mobile_number: "",
    },
  });
  const [showOtpForm, setShowOtpForm] = useState(false);

  //   mobile form
  const [mobileNumber, setMobileNumber] = useState();
  const postMobileNumApi = useFetch({
    url: `user/login_otp`,
    noHeader: true,

    method: "POST",
    data: { phone_number: fixNumbers(mobileNumber) },
    trigger: false,
    argFunc: (res) => {
      setShowOtpForm(true);
      setTimeLeft(120);
      reset();
    },
    errMessage: (res) => {
      if (res.response.data.data == "max_try_reach_in_two_minute") {
        toast.error("  برای دریافت کد  یکبار مصرف دقایقی دیگر اقدام نمایید.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    },
  });
  const onSubmitMobile = (data) => {
    setMobileNumber(data.mobile_number);
    postMobileNumApi.reFetch();
  };
  //   otp form
  const [otpCode, setOtpCode] = useState();
  const onSubmitOtp = (data) => {
    setOtpCode(data.code);
    postOtpCodeApi.reFetch();
  };

  const [timeLeft, setTimeLeft] = useState(120);

  useEffect(() => {
    if (!timeLeft) return;
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const { authDispatch } = useAuth();
  const postOtpCodeApi = useFetch({
    url: `user/check_otp`,
    method: "POST",
    data: { code: otpCode, phone_number: fixNumbers(mobileNumber) },
    trigger: false,
    noHeader: true,
    // caller: props.getUser,
    argFunc: (res) => {
      if (res.data === "not_valid_data") {
        toast.error("کد وارد شده صحیح نمی‌باشد", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        authDispatch({
          type: "LOGIN",
          token: res.access,
          refresh: res.refresh,
        });
        props.setOpenModal(false);
      }
    },
  });

  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-2/5"
        isNotBackdropClick
        disableEscapeKeyDown={true}
      >
        <div className="md:px-12 md:py-6">
          <div className=" mb-4 text-sm md:text-base leading-7 text-center">
            <span>
              برای {props.caseType} ابتدا باید شماره موبایل خود را وارد کرده و
              سپس کد یکبار مصرف را دریافتی را وارد نمایید.
            </span>
          </div>
          {!showOtpForm ? (
            <form onSubmit={handleSubmit(onSubmitMobile)}>
              <div className="flex justify-center mb-4">
                <img className="w-32" src={mobileIcon} />
              </div>
              <div className="">
                <MuiTextFieldHook
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  label="شماره موبایل"
                  name="mobile_number"
                  control={control}
                  register={{
                    required: true,
                    maxLength: 11,
                    minLength: 11,
                  }}
                />
                {errors.mobile_number && (
                  <span className="text-sm text-myred-400">
                    شماره موبایل باید ۱۱ رقم باشد.
                  </span>
                )}
              </div>
              <div className="mt-4">
                <MuiButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  text="دریافت کد یکبار مصرف"
                  isFullWidth
                />
              </div>
            </form>
          ) : (
            <>
              <form onSubmit={handleSubmit(onSubmitOtp)}>
                <div className="flex justify-center mb-4">
                  <img className="w-32" src={otpIcon} />
                </div>
                <div className="">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    label="کد یکبار مصرف"
                    name="code"
                    control={control}
                    register={{
                      required: true,
                      maxLength: 5,
                      minLength: 5,
                    }}
                  />
                  {errors.code && (
                    <span className="text-sm text-myred-400">
                      کدیکبار مصرف باید ۵ رقم باشد.
                    </span>
                  )}
                </div>
                <div className="text-sm mt-2 mb-4">
                  ارسال مجدد کد پس از{" "}
                  <span className="text-myblue-400 font-bold text-base">
                    {timeLeft}
                  </span>{" "}
                  ثانیه
                </div>
                <div className="mt-4">
                  {timeLeft === 0 ? (
                    <MuiButton
                      variant="contained"
                      color="primary"
                      text="ارسال مجدد"
                      isFullWidth
                      onClick={() => {
                        setTimeLeft(120);
                        postMobileNumApi.reFetch();
                      }}
                    />
                  ) : (
                    <MuiButton
                      type="submit"
                      variant="contained"
                      color="primary"
                      text="تایید"
                      isFullWidth
                    />
                  )}
                </div>
              </form>
            </>
          )}
        </div>
      </MuiModal>
    </>
  );
};

export default OtpModal;
